import { Navigate } from 'react-router-dom';

const Root = () => {
    const getRootUrl = () => {
        let url = 'events';
        return url;
    };

    const url = getRootUrl();

    return <Navigate to={`/events/list`} />;
};

export default Root;